import { useMemo } from 'react'

import { Contract, Feature } from 'schema/contract'
import PortalDailyDataAccordion, {
  MetricRowConfig,
  TableRowWithDate,
  createDateList,
  useQuantityMap,
} from './portal-daily-data-accordion'

const AthomeDailyDataAccordion = ({
  contract,
}: {
  contract?: Contract | Feature
}) => {
  const dates = useMemo(createDateList, [])

  const detailPcMap = useQuantityMap(contract?.athome?.detailPvForPC)
  const detailSpMap = useQuantityMap(contract?.athome?.detailPvForSmartphone)
  const detailFeatureMap = useQuantityMap(
    contract?.athome?.detailPvForFeaturephone
  )
  const documentRequestMap = useQuantityMap(contract?.athome?.documentRequest)
  const documentRequestPcMap = useQuantityMap(
    contract?.athome?.documentRequestForPC
  )
  const documentRequestSpMap = useQuantityMap(
    contract?.athome?.documentRequestForSmartphone
  )
  const documentRequestFeatureMap = useQuantityMap(
    contract?.athome?.documentRequestForFeaturephone
  )
  const documentRequestLineMap = useQuantityMap(
    contract?.athome?.documentRequestForLINE
  )
  const documentRequestFreeCallMap = useQuantityMap(
    contract?.athome?.documentRequestForFreeCall
  )
  const favoriteMap = useQuantityMap(contract?.athome?.favoriteCount)
  const movieMap = useQuantityMap(contract?.athome?.moviePlayCount)

  const rows = useMemo<TableRowWithDate[]>(() => {
    return dates.map<TableRowWithDate>((date) => {
      const key = date.key

      return {
        date: date.label,
        detailPc: detailPcMap[key] ?? 0,
        detailSp: detailSpMap[key] ?? 0,
        detailFeature: detailFeatureMap[key] ?? 0,
        documentRequest: documentRequestMap[key] ?? 0,
        documentRequestPc: documentRequestPcMap[key] ?? 0,
        documentRequestSp: documentRequestSpMap[key] ?? 0,
        documentRequestFeature: documentRequestFeatureMap[key] ?? 0,
        documentRequestLine: documentRequestLineMap[key] ?? 0,
        documentRequestFreeCall: documentRequestFreeCallMap[key] ?? 0,
        favorite: favoriteMap[key] ?? 0,
        movie: movieMap[key] ?? 0,
      }
    })
  }, [
    dates,
    detailFeatureMap,
    detailPcMap,
    detailSpMap,
    documentRequestFeatureMap,
    documentRequestFreeCallMap,
    documentRequestLineMap,
    documentRequestMap,
    documentRequestPcMap,
    documentRequestSpMap,
    favoriteMap,
    movieMap,
  ])

  const metricRows = useMemo<MetricRowConfig[]>(
    () => [
      {
        key: 'detailPc',
        label: (
          <>
            <span>詳細PV</span>
            <br />
            (PC)
          </>
        ),
      },
      {
        key: 'detailSp',
        label: (
          <>
            <span>詳細PV</span>
            <br />
            (スマホ)
          </>
        ),
      },
      {
        key: 'detailFeature',
        label: (
          <>
            <span>詳細PV</span>
            <br />
            (ケータイ)
          </>
        ),
      },
      { key: 'documentRequest', label: '資料請求(合計)' },
      {
        key: 'documentRequestPc',
        label: (
          <>
            <span>資料請求</span>
            <br />
            (PC)
          </>
        ),
      },
      {
        key: 'documentRequestSp',
        label: (
          <>
            <span>資料請求</span>
            <br />
            (スマホ)
          </>
        ),
      },
      {
        key: 'documentRequestFeature',
        label: (
          <>
            <span>資料請求</span>
            <br />
            (ケータイ)
          </>
        ),
      },
      {
        key: 'documentRequestLine',
        label: (
          <>
            <span>資料請求</span>
            <br />
            (LINE)
          </>
        ),
      },
      {
        key: 'documentRequestFreeCall',
        label: (
          <>
            <span>資料請求</span>
            <br />
            (無料通話)
          </>
        ),
      },
      {
        key: 'favorite',
        label: (
          <>
            <span>お気に入り</span>
            <br />
            登録数
          </>
        ),
      },
      {
        key: 'movie',
        label: (
          <>
            <span>ムービー</span>
            <br />
            再生数
          </>
        ),
      },
    ],
    []
  )

  if (!contract?.athome) {
    return null
  }

  return <PortalDailyDataAccordion rows={rows} metricRows={metricRows} />
}

export default AthomeDailyDataAccordion
